import { render, staticRenderFns } from "./AlarmStatistics.vue?vue&type=template&id=5ef378b6&scoped=true&"
import script from "./AlarmStatistics.vue?vue&type=script&lang=js&"
export * from "./AlarmStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AlarmStatistics.vue?vue&type=style&index=0&id=5ef378b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef378b6",
  null
  
)

export default component.exports